import React from 'react';
import { ReactComponent as Logo } from '../assets/images/logo.svg';
import { Link } from 'react-router-dom';
import { pageItems } from '../data/data'

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import styled from "styled-components";

export default function Header(props) {

  const drawerWidth = 240;
  const navItems = pageItems;
  
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h3" sx={{ my: 2 }}>
        <Link to="/">
          <Logo className='logo-home' />
        </Link>
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <li className='navbtnmo' key={item.key} >
            <Link 
              to={item.link}
              target={item.target}
            >
              {item.name}
            </Link>
          </li>
        ))}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  const StyledAppBar = styled(AppBar)`
  && {
    background-color: #fff;
    box-shadow: 2px 2px 2px 1px rgb(0 0 0 / 4%);
  }
`;

  return (
      <header>
        <div className="header-inner">
          <CssBaseline />
            <StyledAppBar component="nav">
              <Toolbar>

                <Typography
                  variant="h6"
                  component="div"
                  sx={{ flexGrow: 1, display: { sm: 'block' } }}
                >
                  <Link to="/">
                    <Logo className='logo-home' />
                  </Link>
                </Typography>

                <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                  {navItems.map((item) => (
                    <div className='navbtn' key={item.key} >
                      <Link 
                        sx={{ color: '#000' }}
                        to={item.link}
                        target={item.target}
                        className={`${item.key}btn`}
                      >
                        {item.name}
                      </Link>
                    </div>
                  ))}
                </Box>

                <IconButton
                    color="#000"
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{ ml: 2, display: { sm: 'none' } }}
                  >
                    <MenuIcon />
                </IconButton>
              </Toolbar>
            </StyledAppBar>

            <nav>
              <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                  display: { xs: 'block', sm: 'none' },
                  '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
              >
                {drawer}
              </Drawer>
            </nav>
            
        </div>
      </header>
    )
}